import React, { useEffect, useState } from 'react';
import Announcement from '../Home/Announcement';
import parse from 'html-react-parser';

function AllAnnouncements({page_title}) {

    useEffect(() => {
                    document.title = page_title;
                }, [page_title]);

    const [announcements, setAnnouncements] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    
      useEffect(() => {
              fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=getAllAnnouncements")
                  .then(response => response.json())
                  .then(data => {
                      if (data.success) {
                          setAnnouncements(data.announcements);
                      } else {
                          console.error("API Error:", data.error);
                      }
                  })
                  .catch(error => console.error("Error fetching announcements:", error));
        }, []);
    
        const formatDate = (dateString) => {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = date.toLocaleString('en-US', { month: 'short' });
            const year = date.getFullYear();
    
            return `${day}-${month}-${year}`;
        };

    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = announcements.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(announcements.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
      <>
        <div className='instructions_section'>
            <div className="instructions_wrapper">
                <h2 className='instructions_title'>
                    Announcements
                </h2>

                <hr class="instructions_hr"/>

                {currentItems.map((announcement, index) => {

                    return(
                        <Announcement
                            key={announcement.id}
                            link={'/announcement/' + announcement.id + '/' + announcement.title.toLowerCase().replace(/\s+/g, '-')}
                            fullstring="false"
                            last={index === announcements.length - 1 ? "true" : "false"}
                            title={parse(announcement.title)}
                            date={formatDate(announcement.date)}
                            content={parse(announcement.body)}
                        />
                    )                 

                })}

                {/* Pagination */}
                        <div style={{ marginTop: "1rem", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem" }}>
                            
                            {/* Left Arrow */}
                            <button
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                                style={{
                                    height: "40px",
                                    width:"40px",
                                    backgroundColor: "#eee",
                                    color: "#000",
                                    border: "none",
                                    borderRadius: "100px",
                                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                                    opacity: currentPage === 1 ? 0.5 : 1
                                }}
                            >
                                <span className="fa-solid fa-arrow-left"></span>
                            </button>

                            {/* Page Info */}
                            <span>
                                Page {currentPage} of {totalPages}
                            </span>

                            {/* Right Arrow */}
                            <button
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                style={{
                                    height: "40px",
                                    width:"40px",
                                    backgroundColor: "#eee",
                                    color: "#000",
                                    border: "none",
                                    borderRadius: "100px",
                                    cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                                    opacity: currentPage === totalPages ? 0.5 : 1
                                }}
                            >
                                <span className="fa-solid fa-arrow-right"></span>
                            </button>
                        </div>


            </div>
        </div>
      </>
    );
}

export default AllAnnouncements;